import { ArrowRight, BadgeCheck, BarChart3, Boxes, CheckCircle2, FileSpreadsheet, Landmark, Mail, MapPin, Phone, ShieldCheck, Users2, Wallet } from "lucide-react";

const FEATURE_ICONS = [FileSpreadsheet, Boxes, BarChart3, Users2, Wallet, ShieldCheck];
const money = (n) => `Rp ${Number(n || 0).toLocaleString("id-ID")}`;

const WaIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="currentColor" aria-hidden="true">
    <path d="M16.04 3C9.02 3 3.32 8.7 3.32 15.72c0 2.24.59 4.42 1.71 6.35L3.2 28.8l6.9-1.79a12.66 12.66 0 0 0 5.94 1.5h.01c7.01 0 12.72-5.7 12.72-12.72C28.77 8.7 23.06 3 16.04 3Zm0 23.36h-.01a10.5 10.5 0 0 1-5.36-1.47l-.38-.23-3.99 1.04 1.07-3.89-.25-.4a10.55 10.55 0 0 1-1.62-5.64c0-5.83 4.75-10.58 10.59-10.58 2.83 0 5.48 1.1 7.48 3.1a10.5 10.5 0 0 1 3.1 7.48c0 5.84-4.75 10.59-10.58 10.59Zm5.8-7.93c-.32-.16-1.88-.93-2.17-1.03-.29-.11-.5-.16-.72.16-.21.32-.82 1.03-1 1.24-.19.21-.37.24-.69.08-.32-.16-1.34-.5-2.56-1.58-.95-.85-1.59-1.89-1.77-2.21-.19-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.1-.21.05-.4-.03-.56-.08-.16-.72-1.73-.98-2.37-.26-.62-.52-.54-.72-.55l-.61-.01c-.21 0-.56.08-.85.4-.29.32-1.11 1.09-1.11 2.65 0 1.56 1.14 3.07 1.3 3.29.16.21 2.24 3.42 5.43 4.8.76.33 1.35.52 1.81.67.76.24 1.46.21 2.01.13.61-.09 1.88-.77 2.14-1.51.27-.74.27-1.38.19-1.51-.08-.13-.29-.21-.61-.37Z" />
  </svg>
);

export default function Landing({ content, onEnter }) {
  const c = content || { app_name: "Kiyana IAC Solution", features: [], packages: [] };
  const waLink = c.whatsapp_number ? `https://wa.me/${String(c.whatsapp_number).replace(/\D/g, "")}?text=${encodeURIComponent(c.whatsapp_message || "")}` : null;
  const brandShort = (c.app_name || "K").trim().charAt(0).toUpperCase();
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <div className="landing" data-testid="landing-page">
      <header className="ld-nav">
        <div className="ld-container ld-nav-inner">
          <div className="ld-brand"><span className="brand-mark small">{brandShort}<span>•</span></span> {c.app_name}</div>
          <nav className="ld-links">
            <button data-testid="nav-features" onClick={() => scrollTo("fitur")}>Fitur</button>
            <button data-testid="nav-pricing" onClick={() => scrollTo("harga")}>Harga</button>
            <button data-testid="nav-contact" onClick={() => scrollTo("kontak")}>Kontak</button>
          </nav>
          <div className="ld-nav-cta">
            <button data-testid="landing-login-button" className="secondary-btn nowrap" onClick={() => onEnter("login")}>Masuk</button>
            {c.allow_registration !== false && <button data-testid="landing-register-button" className="primary-btn nowrap" onClick={() => onEnter("register")}>Coba Gratis 7 Hari</button>}
          </div>
        </div>
      </header>

      <section className="ld-hero">
        <div className="ld-container ld-hero-grid">
          <div className="ld-hero-copy">
            <p className="eyebrow">{c.tagline}</p>
            <h1 data-testid="hero-title">{c.hero_title}</h1>
            <p className="ld-sub">{c.hero_subtitle}</p>
            <div className="ld-hero-actions">
              {c.allow_registration !== false && <button data-testid="hero-register-button" className="primary-btn" onClick={() => onEnter("register")}>Mulai Gratis Sekarang <ArrowRight size={17} /></button>}
              {waLink && <a data-testid="hero-wa-button" className="ld-wa-btn" href={waLink} target="_blank" rel="noreferrer"><WaIcon size={18} /> Konsultasi via WhatsApp</a>}
            </div>
            <div className="ld-hero-points">
              {["Tanpa kartu kredit", "Data terenkripsi & terisolasi", "Dukungan Bahasa Indonesia"].map((p) => (
                <span key={p}><CheckCircle2 size={14} /> {p}</span>
              ))}
            </div>
          </div>
          <div className="ld-hero-visual" aria-hidden="true">
            <div className="ld-mock">
              <div className="ld-mock-head"><span /><span /><span /></div>
              <div className="ld-mock-kpis">
                <div><small>Penjualan Bulan Ini</small><b>Rp 128,4 jt</b><em className="up">▲ 12,5%</em></div>
                <div><small>Kas & Bank</small><b>Rp 342,1 jt</b><em className="up">▲ 4,2%</em></div>
                <div><small>Piutang Jatuh Tempo</small><b>Rp 18,7 jt</b><em className="down">3 invoice</em></div>
              </div>
              <div className="ld-mock-chart">
                {[38, 55, 42, 70, 58, 82, 64, 90, 74, 96, 84, 100].map((h, i) => <i key={i} style={{ height: `${h}%` }} />)}
              </div>
              <div className="ld-mock-rows">
                <div><span className="dot ok" /> INV-2026-0812 · PT Sinar Jaya <b>Lunas</b></div>
                <div><span className="dot warn" /> INV-2026-0811 · CV Mitra Abadi <b>Sebagian</b></div>
                <div><span className="dot ok" /> Jurnal HPP otomatis diposting <b>✓</b></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ld-band">
        <div className="ld-container ld-band-inner">
          {[["Jurnal selalu seimbang", "Debit = Kredit, otomatis"], ["Bahasa Indonesia & IDR", "Dibuat untuk bisnis lokal"], ["Multi-perusahaan aman", "Isolasi data per tenant"], ["Siap pajak", "PPN keluaran & masukan"]].map(([t, s]) => (
            <div key={t}><BadgeCheck size={18} /><div><b>{t}</b><small>{s}</small></div></div>
          ))}
        </div>
      </section>

      <section className="ld-section" id="fitur">
        <div className="ld-container">
          <p className="eyebrow center">FITUR UNGGULAN</p>
          <h2 className="ld-h2">Semua yang bisnis Anda butuhkan, satu platform</h2>
          <div className="ld-features">
            {(c.features || []).map((f, i) => {
              const Icon = FEATURE_ICONS[i % FEATURE_ICONS.length];
              return (
                <div className="ld-feature" key={i} data-testid={`feature-card-${i}`}>
                  <span className="ld-fic"><Icon size={19} /></span>
                  <h3>{f.title}</h3>
                  <p>{f.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="ld-section alt" id="harga">
        <div className="ld-container">
          <p className="eyebrow center">HARGA SEDERHANA</p>
          <h2 className="ld-h2">Mulai gratis, upgrade saat bisnis bertumbuh</h2>
          <div className="ld-pricing">
            {(c.packages || []).map((p, i) => {
              const isTrial = !p.price_monthly;
              const hotIdx = (c.packages || []).findIndex((x) => x.price_monthly > 0);
              const hot = i === hotIdx;
              return (
                <div className={`ld-price-card ${hot ? "hot" : ""}`} key={p.name} data-testid={`price-card-${i}`}>
                  {hot && <span className="ld-price-badge">Paling Populer</span>}
                  <h3>{p.label || p.name}</h3>
                  <div className="ld-price">{isTrial ? "Gratis" : money(p.price_monthly)}<small>{isTrial ? "7 hari penuh" : "/bulan"}</small></div>
                  <ul>
                    {(p.features && p.features.length ? p.features : [
                      p.max_users ? `Hingga ${p.max_users} pengguna` : "Pengguna tanpa batas",
                      p.max_invoices ? `${p.max_invoices} invoice/bulan` : "Invoice tanpa batas",
                      "Semua modul akuntansi & stok",
                    ]).map((f) => <li key={f}><CheckCircle2 size={14} /> {f}</li>)}
                  </ul>
                  <button className={hot ? "primary-btn" : "secondary-btn"} data-testid={`price-cta-${i}`} onClick={() => onEnter("register")}>{isTrial ? "Coba Gratis" : "Mulai Berlangganan"}</button>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="ld-cta">
        <div className="ld-container ld-cta-inner">
          <div>
            <h2>Siap merapikan keuangan bisnis Anda?</h2>
            <p>Daftar hari ini dan rasakan pembukuan yang otomatis, akurat, dan bebas repot.</p>
          </div>
          <div className="ld-cta-actions">
            {c.allow_registration !== false && <button data-testid="cta-register-button" className="ld-cta-btn" onClick={() => onEnter("register")}>Daftar Sekarang — Gratis <ArrowRight size={17} /></button>}
            {waLink && <a className="ld-wa-btn invert" href={waLink} target="_blank" rel="noreferrer"><WaIcon size={18} /> Tanya Tim Kami</a>}
          </div>
        </div>
      </section>

      <footer className="ld-footer" id="kontak">
        <div className="ld-container ld-footer-grid">
          <div>
            <div className="ld-brand light"><span className="brand-mark small">{brandShort}<span>•</span></span> {c.app_name}</div>
            <p className="ld-footer-text">{c.footer_text}</p>
          </div>
          <div>
            <h4>Hubungi Kami</h4>
            <ul className="ld-contact" data-testid="contact-list">
              {waLink && <li><a href={waLink} target="_blank" rel="noreferrer" data-testid="contact-wa"><span className="ld-cic wa"><WaIcon size={14} /></span> {c.contact_phone || c.whatsapp_number} (WhatsApp)</a></li>}
              {c.contact_email && <li><a href={`mailto:${c.contact_email}`} data-testid="contact-email"><span className="ld-cic"><Mail size={14} /></span> {c.contact_email}</a></li>}
              {c.contact_phone && <li><span className="ld-cic"><Phone size={14} /></span> {c.contact_phone}</li>}
              {c.contact_address && <li><span className="ld-cic"><MapPin size={14} /></span> {c.contact_address}</li>}
            </ul>
          </div>
          <div>
            <h4>Produk</h4>
            <ul className="ld-contact plain">
              <li><button onClick={() => scrollTo("fitur")}>Fitur</button></li>
              <li><button onClick={() => scrollTo("harga")}>Harga</button></li>
              <li><button onClick={() => onEnter("login")}>Masuk</button></li>
              {c.allow_registration !== false && <li><button onClick={() => onEnter("register")}>Daftar Gratis</button></li>}
            </ul>
          </div>
        </div>
        <div className="ld-container ld-footer-bottom">© {new Date().getFullYear()} {c.app_name}. Seluruh hak cipta dilindungi. <span className="ld-foot-sec"><Landmark size={12} /> Pembukuan berpasangan · <ShieldCheck size={12} /> Data terenkripsi</span></div>
      </footer>

      {waLink && (
        <a className="wa-float" data-testid="wa-float-button" href={waLink} target="_blank" rel="noreferrer" title="Chat via WhatsApp">
          <WaIcon size={26} />
        </a>
      )}
    </div>
  );
}
